import { combineReducers } from 'redux'
import app from './app-reducer'
import contentful from './contentful-reducer'
import elasticsearch from './elasticsearch/elasticsearch-reducer'
import { filtersReducer } from './filters/filters-reducer'
import { productTablesReducer } from './product-tables/product-table-reducer'
import { calculatorsReducer } from './calculators/calculators-reducer'
import componentReducer from './component/component-reducer'
import { sortReducer } from './sorts/sort-reducers'
import reviewsReducer from './reviews/reviews-reducer'
import smeReducer from './sme/sme-reducer'

export default combineReducers({
  app,
  contentful,
  elasticsearch,
  filters: filtersReducer,
  productTables: productTablesReducer,
  calculators: calculatorsReducer,
  components: componentReducer,
  sorts: sortReducer,
  reviews: reviewsReducer,
  sme: smeReducer,
})
